import { useRouter } from 'next/router';
import React, { useState } from 'react'
import { getCustomerCookie, getIsAuthenticateCookie } from '../../../api/cookies'
import { GetPlans } from '../../../api/selfserve'
import { getPlans, setLoader } from '../../../redux/actions/myaccountActions'
import { useDispatch } from "react-redux";
import MyaccountV2 from '../../../components/myaccountV2'
import { blockSalesTouchPoint } from '../../../utils/myaccount'

export async function getServerSideProps() {
    return {
        props: {
            pageName: 'myaccount'
        },
    };
}


const Plans = () => {
    const dispatch:any = useDispatch();
    const router = useRouter()
    const [, setPlans] = useState<any>([])
    const isAuthenticated = getIsAuthenticateCookie()
    React.useEffect(() =>{
      dispatch(getPlans([]));
        dispatch(setLoader(true))
        if(!isAuthenticated){
            router.push(`/login?next=/account/plans`)
            return
        }
        const customerCookie = getCustomerCookie();
        let get_plans_data = {};
        if (customerCookie) {
          get_plans_data = {
            token_id: customerCookie.token_id,
            phone: customerCookie.phone,
          };
          GetPlans({
            application: "website",
            data: JSON.stringify(get_plans_data),
          })
            .then((res: any) => {
              if (res.data.plans) {
                dispatch(getPlans([...res.data.plans]));
                dispatch(setLoader(false))
                setPlans([...res.data.plans])
              }
            })
            .catch(() => {
                dispatch(setLoader(false))
            });
        }
    },[])
  return (
      <MyaccountV2 isBlockSalesPoint={!blockSalesTouchPoint(router)} page="plans" authenticate={isAuthenticated}/>
  )
}

export default Plans;
